import { connect } from 'react-redux';
import HeroImage from './HeroImage';

const mapStateToProps = ({
  content: { jumbotron: { treatments, title }}
}) => ({
  treatments,
  title
});

export default connect(mapStateToProps, null)(HeroImage);
